import { CustomIcons } from '@shared/icons/CustomIcons'
import { Editor } from '@tiptap/react'
import { Button, Flex, Tooltip } from 'antd'
import { TextBold, TextItalic, TextUnderline } from 'iconsax-react'
import { useTranslation } from 'react-i18next'

type Props = {
  editor: Editor
}

export const MenuTextButtons = ({ editor }: Props) => {
  const { t } = useTranslation()

  return (
    <Flex gap="8px">
      <Tooltip title={t('editor.bold')}>
        <Button
          onClick={() => editor.chain().focus().toggleBold().run()}
          icon={<TextBold size={14} />}
        />
      </Tooltip>

      <Tooltip title={t('editor.italic')}>
        <Button
          onClick={() => editor.chain().focus().toggleBold().run()}
          icon={<TextItalic size={14} />}
        />
      </Tooltip>

      <Tooltip title={t('editor.strike')}>
        <Button
          onClick={() => editor.chain().focus().toggleStrike().run()}
          icon={CustomIcons.Strike(14)}
        />
      </Tooltip>

      <Tooltip title={t('editor.underline')}>
        <Button
          onClick={() => editor.chain().focus().toggleUnderline().run()}
          icon={<TextUnderline size={16} />}
        />
      </Tooltip>
    </Flex>
  )
}
